module.exports = "/images/rts.white.svg?4a96c2343dc40d098c8f837ef27c0af8";